import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const StoryClusterPage = lazy(
  () =>
    import('./StoryClusterPage.eager').then(mod => ({
      default: mod.StoryClusterPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
